// extracted by mini-css-extract-plugin
export const root = "image-composition-text-module--root--3Mph5";
export const image = "image-composition-text-module--image--3QlBA";
export const text = "image-composition-text-module--text--Q4QcR";
export const mobCaption = "image-composition-text-module--mobCaption--3hHEg";